import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const TypeFormatter = ({ row }) => {
    const { t } = useTranslation();
    const { is_bom_express } = row;

    return (
        <Typography variant="caption">
            {is_bom_express ? t('BOM Express') : t('Professional')}
        </Typography>
    );
};

TypeFormatter.propTypes = {
    row: PropTypes.object,
};

export default TypeFormatter;
